import { createSlice } from '@reduxjs/toolkit';
import {
  postResume,
  getAllResume,
  getResume,
  deleteResume,
  updateHighlightResume,
  getResumeByUsername
} from 'redux/services/UserResumeService';

export const UserResumeSlice = createSlice({
  name: 'search',
  initialState: {},
  reducers: {},
});

export const handlePostResume = (payload) => async () => {
  return postResume(payload);
};

export const handleGetAllResume = (payload) => async () => {
  return getAllResume(payload);
};

export const handleGetResume = (payload) => async () => {
  return getResume(payload);
};

export const handleDeleteResume = (payload) => async () => {
  return deleteResume(payload);
};

export const handleUpdateHighlightResume = (payload) => async () => {
  return updateHighlightResume(payload);
};

export const handleGetHighlightedResumeByUsername = (payload) => async () => {
  return getResumeByUsername(payload);
};

export default UserResumeSlice.reducer;
